// Dependencies
import React, { Component } from 'react';
import base64 from 'crypto-js/enc-base64';
import utf8 from 'crypto-js/enc-utf8';
import PageTitleComponent from '../../components/page-title/page-title';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';

class PortalEmpregoProxyPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            appUrl: ""
         };
    }

    componentDidMount() {
        this.accessPortalEmpregoPlatform();
    }

    accessPortalEmpregoPlatform() {
        const encodedBallotRef = utf8.parse(this.props.ballot.ballotRef); 
        this.setState({
            appUrl: process.env.REACT_APP_PORTAL_EMPREGO_URL + base64.stringify(encodedBallotRef)
        });
    }

    render() {
        return (     
            <div>
                <PageTitleComponent title={this.props.t("portal-emprego.title")} />
                {
                    this.state.appUrl !== "" ? 
                        <iframe style={{width:"100vw", height:"90vh", border:"none", display:"block"}} src={this.state.appUrl}></iframe>
                        : null
                }
            </div>
         );
    }
}
  
const mapStateToProps = (state) => {
    return {
        ballot: state.profile.ballot
    } 
};

export default connect(mapStateToProps, undefined)(withTranslation(PortalEmpregoProxyPage));